import Task from 'components/Content/GameDetails/Tasks/Task/Task';
import withTaskProps from 'viewModel/content/gameDetails/tasks/task/withTaskProps';

export default withTaskProps(Task);
